import {
	Button,
	PanelRow,
	PanelBody,
	ToggleControl,
	Dropdown,
	Popover,
	SelectControl,
	RangeControl,
	Panel,
	DropdownMenu,
	ColorPicker,
	ColorPalette,
	ToolsPanelItem,
	ComboboxControl,
	MenuGroup,
	MenuItem,
	TextareaControl,
	Spinner,
	Tooltip,
	DateTimePicker,
	DatePicker,
} from "@wordpress/components";
import { applyFilters } from "@wordpress/hooks";
import apiFetch from "@wordpress/api-fetch";

import { __experimentalInputControl as InputControl } from "@wordpress/components";
import {
	useState,
	useEffect,
	Component,
	RawHTML,
	////
	useRef,
	////
} from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Icon, close } from "@wordpress/icons";
import CBDropdown from "../../components/dropdown";
import PGtoggle from "../toggle";
function Html(props) {
	if (!props.warn) {
		return null;
	}
	const [animateOn, setanimateOn] = useState(props.animateOn);
	var [rules, setrules] = useState(
		animateOn?.rules == null || animateOn?.rules == undefined ? [] : animateOn.rules
	);
	useEffect(() => {
		props.onChange(animateOn);
	}, [animateOn]);
	useEffect(() => {
		var animateOnX = { ...animateOn };
		animateOnX.rules = rules;
		setanimateOn(animateOnX);
	}, [rules]);
	var animateListArgsBasic = {
		backInDown: { label: __("backInDown", "woocommerce-products-slider"), value: "backInDown" },
		backInLeft: { label: __("backInLeft", "woocommerce-products-slider"), value: "backInLeft" },
		backInRight: {
			label: __("backInRight", "woocommerce-products-slider"),
			value: "backInRight",
			//isPro: true,
		},
		backInUp: {
			label: __("backInUp", "woocommerce-products-slider"),
			value: "backInUp",
			//isPro: true,
		},
		bounceIn: { label: __("bounceIn", "woocommerce-products-slider"), value: "bounceIn" },
		bounceInDown: {
			label: __("bounceInDown", "woocommerce-products-slider"),
			value: "bounceInDown",
			//isPro: true,
		},
		bounceInLeft: {
			label: __("bounceInLeft", "woocommerce-products-slider"),
			value: "bounceInLeft",
			//isPro: true,
		},
		bounceInRight: {
			label: __("bounceInRight", "woocommerce-products-slider"),
			value: "bounceInRight",
			//isPro: true,
		},
		bounceInUp: {
			label: __("bounceInUp", "woocommerce-products-slider"),
			value: "bounceInUp",
			//isPro: true,
		},
		fadeIn: { label: __("fadeIn", "woocommerce-products-slider"), value: "fadeIn" },
		fadeInDown: {
			label: __("fadeInDown", "woocommerce-products-slider"),
			value: "fadeInDown",
			//isPro: true,
		},
		fadeInDownBig: {
			label: __("fadeInDownBig", "woocommerce-products-slider"),
			value: "fadeInDownBig",
			//isPro: true,
		},
		fadeInLeft: {
			label: __("fadeInLeft", "woocommerce-products-slider"),
			value: "fadeInLeft",
			//isPro: true,
		},
		fadeInLeftBig: {
			label: __("fadeInLeftBig", "woocommerce-products-slider"),
			value: "fadeInLeftBig",
			//isPro: true,
		},
		fadeInRight: {
			label: __("fadeInRight", "woocommerce-products-slider"),
			value: "fadeInRight",
			//isPro: true,
		},
		fadeInRightBig: {
			label: __("fadeInRightBig", "woocommerce-products-slider"),
			value: "fadeInRightBig",
			//isPro: true,
		},
		fadeInUp: {
			label: __("fadeInUp", "woocommerce-products-slider"),
			value: "fadeInUp",
			//isPro: true,
		},
		fadeInUpBig: {
			label: __("fadeInUpBig", "woocommerce-products-slider"),
			value: "fadeInUpBig",
			//isPro: true,
		},
		fadeInTopLeft: {
			label: __("fadeInTopLeft", "woocommerce-products-slider"),
			value: "fadeInTopLeft",
			//isPro: true,
		},
		fadeInTopRight: {
			label: __("fadeInTopRight", "woocommerce-products-slider"),
			value: "fadeInTopRight",
			//isPro: true,
		},
		fadeInBottomRight: {
			label: __("fadeInBottomRight", "woocommerce-products-slider"),
			value: "fadeInBottomRight",
			//isPro: true,
		},
		fadeInBottomLeft: {
			label: __("fadeInBottomLeft", "woocommerce-products-slider"),
			value: "fadeInBottomLeft",
			//isPro: true,
		},
		rotateIn: { label: __("rotateIn", "woocommerce-products-slider"), value: "rotateIn" },
		rotateInDownLeft: {
			label: __("rotateInDownLeft", "woocommerce-products-slider"),
			value: "rotateInDownLeft",
			//isPro: true,
		},
		rotateInDownRight: {
			label: __("rotateInDownRight", "woocommerce-products-slider"),
			value: "rotateInDownRight",
			//isPro: true,
		},
		rotateInUpLeft: {
			label: __("rotateInUpLeft", "woocommerce-products-slider"),
			value: "rotateInUpLeft",
			//isPro: true,
		},
		rotateInUpRight: {
			label: __("rotateInUpRight", "woocommerce-products-slider"),
			value: "rotateInUpRight",
			//isPro: true,
		},
		zoomIn: { label: __("zoomIn", "woocommerce-products-slider"), value: "zoomIn", isPro: true },
		zoomInDown: {
			label: __("zoomInDown", "woocommerce-products-slider"),
			value: "zoomInDown",
			//isPro: true,
		},
		zoomInLeft: {
			label: __("zoomInLeft", "woocommerce-products-slider"),
			value: "zoomInLeft",
			//isPro: true,
		},
		zoomInRight: {
			label: __("zoomInRight", "woocommerce-products-slider"),
			value: "zoomInRight",
			//isPro: true,
		},
		zoomInUp: {
			label: __("zoomInUp", "woocommerce-products-slider"),
			value: "zoomInUp",
			//isPro: true,
		},
		slideInDown: {
			label: __("slideInDown", "woocommerce-products-slider"),
			value: "slideInDown",
			//isPro: true,
		},
		slideInLeft: {
			label: __("slideInLeft", "woocommerce-products-slider"),
			value: "slideInLeft",
			//isPro: true,
		},
		slideInRight: {
			label: __("slideInRight", "woocommerce-products-slider"),
			value: "slideInRight",
			//isPro: true,
		},
		slideInUp: {
			label: __("slideInUp", "woocommerce-products-slider"),
			value: "slideInUp",
			//isPro: true,
		},
		backOutDown: {
			label: __("backOutDown", "woocommerce-products-slider"),
			value: "backOutDown",
		},
		backOutLeft: {
			label: __("backOutLeft", "woocommerce-products-slider"),
			value: "backOutLeft",
		},
		backOutRight: {
			label: __("backOutRight", "woocommerce-products-slider"),
			value: "backOutRight",
			//isPro: true,
		},
		backOutUp: {
			label: __("backOutUp", "woocommerce-products-slider"),
			value: "backOutUp",
			//isPro: true,
		},
		bounceOut: { label: __("bounceOut", "woocommerce-products-slider"), value: "bounceOut" },
		bounceOutDown: {
			label: __("bounceOutDown", "woocommerce-products-slider"),
			value: "bounceOutDown",
			//isPro: true,
		},
		bounceOutLeft: {
			label: __("bounceOutLeft", "woocommerce-products-slider"),
			value: "bounceOutLeft",
			//isPro: true,
		},
		bounceOutRight: {
			label: __("bounceOutRight", "woocommerce-products-slider"),
			value: "bounceOutRight",
			//isPro: true,
		},
		bounceOutUp: {
			label: __("bounceOutUp", "woocommerce-products-slider"),
			value: "bounceOutUp",
			//isPro: true,
		},
		fadeOut: { label: __("fadeOut", "woocommerce-products-slider"), value: "fadeOut" },
		fadeOutDown: {
			label: __("fadeOutDown", "woocommerce-products-slider"),
			value: "fadeOutDown",
			//isPro: true,
		},
		fadeOutDownBig: {
			label: __("fadeOutDownBig", "woocommerce-products-slider"),
			value: "fadeOutDownBig",
			//isPro: true,
		},
		fadeOutLeft: {
			label: __("fadeOutLeft", "woocommerce-products-slider"),
			value: "fadeOutLeft",
			//isPro: true,
		},
		fadeOutLeftBig: {
			label: __("fadeOutLeftBig", "woocommerce-products-slider"),
			value: "fadeOutLeftBig",
			//isPro: true,
		},
		fadeOutRight: {
			label: __("fadeOutRight", "woocommerce-products-slider"),
			value: "fadeOutRight",
			//isPro: true,
		},
		fadeOutRightBig: {
			label: __("fadeOutRightBig", "woocommerce-products-slider"),
			value: "fadeOutRightBig",
			//isPro: true,
		},
		fadeOutUp: {
			label: __("fadeOutUp", "woocommerce-products-slider"),
			value: "fadeOutUp",
			//isPro: true,
		},
		fadeOutUpBig: {
			label: __("fadeOutUpBig", "woocommerce-products-slider"),
			value: "fadeOutUpBig",
			//isPro: true,
		},
		fadeOutTopLeft: {
			label: __("fadeOutTopLeft", "woocommerce-products-slider"),
			value: "fadeOutTopLeft",
			//isPro: true,
		},
		fadeOutTopRight: {
			label: __("fadeOutTopRight", "woocommerce-products-slider"),
			value: "fadeOutTopRight",
			//isPro: true,
		},
		fadeOutBottomRight: {
			label: __("fadeOutBottomRight", "woocommerce-products-slider"),
			value: "fadeOutBottomRight",
			//isPro: true,
		},
		fadeOutBottomLeft: {
			label: __("fadeOutBottomLeft", "woocommerce-products-slider"),
			value: "fadeOutBottomLeft",
			//isPro: true,
		},
		rotateOut: { label: __("rotateOut", "woocommerce-products-slider"), value: "rotateOut" },
		rotateOutDownLeft: {
			label: __("rotateOutDownLeft", "woocommerce-products-slider"),
			value: "rotateOutDownLeft",
			//isPro: true,
		},
		rotateOutDownRight: {
			label: __("rotateOutDownRight", "woocommerce-products-slider"),
			value: "rotateOutDownRight",
			//isPro: true,
		},
		rotateOutUpLeft: {
			label: __("rotateOutUpLeft", "woocommerce-products-slider"),
			value: "rotateOutUpLeft",
			//isPro: true,
		},
		rotateOutUpRight: {
			label: __("rotateOutUpRight", "woocommerce-products-slider"),
			value: "rotateOutUpRight",
			//isPro: true,
		},
		zoomOut: {
			label: __("zoomOut", "woocommerce-products-slider"),
			value: "zoomOut",
			//isPro: true,
		},
		zoomOutDown: {
			label: __("zoomOutDown", "woocommerce-products-slider"),
			value: "zoomOutDown",
			//isPro: true,
		},
		zoomOutLeft: {
			label: __("zoomOutLeft", "woocommerce-products-slider"),
			value: "zoomOutLeft",
			//isPro: true,
		},
		zoomOutRight: {
			label: __("zoomOutRight", "woocommerce-products-slider"),
			value: "zoomOutRight",
			//isPro: true,
		},
		zoomOutUp: {
			label: __("zoomOutUp", "woocommerce-products-slider"),
			value: "zoomOutUp",
			//isPro: true,
		},
		slideOutDown: {
			label: __("slideOutDown", "woocommerce-products-slider"),
			value: "slideOutDown",
			//isPro: true,
		},
		slideOutLeft: {
			label: __("slideOutLeft", "woocommerce-products-slider"),
			value: "slideOutLeft",
			//isPro: true,
		},
		slideOutRight: {
			label: __("slideOutRight", "woocommerce-products-slider"),
			value: "slideOutRight",
			//isPro: true,
		},
		slideOutUp: {
			label: __("slideOutUp", "woocommerce-products-slider"),
			value: "slideOutUp",
			//isPro: true,
		},
	};
	let animateListArgs = applyFilters(
		"AnimateOnArgs",
		animateListArgsBasic
	);

	var events = {
		load: { label: __("Page Load", "woocommerce-products-slider"), value: "load" },
		scroll: { label: __("Scroll To", "woocommerce-products-slider"), value: "scroll" },
		mouseover: { label: __("Mouse Over", "woocommerce-products-slider"), value: "mouseover" },
		mouseout: { label: __("Mouse Out", "woocommerce-products-slider"), value: "mouseout" },
		click: { label: __("Click Element", "woocommerce-products-slider"), value: "click" },
	}


	var RemoveAnimateOnGroup = function ({ title, index }) {
		return (
			<>
				<Icon icon={close} onClick={(ev) => {
					var rulesX = [...rules];
					rulesX.splice(index, 1);
					setrules(rulesX);
				}} />
				<span>{title}</span>
			</>
		);
	};
	return (
		<div className="relative">
			<PanelRow className="my-3">
				<div
					// className="bg-gray-700 hover:bg-gray-600 p-2 px-4 text-white inline-block cursor-pointer rounded-sm"
					className="flex gap-2 justify-center my-2 cursor-pointer py-2 px-4 capitalize  bg-gray-700	 text-white font-medium rounded hover:bg-gray-600	 hover:text-white focus:outline-none focus:bg-gray-600	"
					onClick={(ev) => {
						var rulesX = [...rules];
						rulesX.push({ event: "mouseover", title: "", animationName: "backInDown", eventTarget: '.item', duration: "", delay: "", });
						setrules(rulesX);
					}}>
					{__("Add", "woocommerce-products-slider")}
				</div>
			</PanelRow>
			<div className="my-4">
				{rules.map((group, groupIndex) => {
					return (
						<PGtoggle
							title={
								<RemoveAnimateOnGroup title={events[group.event]?.label + " - " + animateListArgs[group.animationName]?.label} index={groupIndex} />
							}
							initialOpen={false} key={groupIndex} >
							<PanelRow className="my-3">
								<label>Event?</label>
								<CBDropdown
									position="bottom right"
									variant="secondary"
									buttonTitle={
										group.event == undefined
											? __("Choose", "woocommerce-products-slider")
											: group.event
									}
									options={events}
									onChange={(option, index) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["event"] = option.value;
										setrules(rulesX);
									}}
									values=""></CBDropdown>
							</PanelRow>
							<PanelRow>
								<label htmlFor="" >
									{__("Target?", "woocommerce-products-slider")}
								</label>
								<InputControl
									className=""
									value={group.eventTarget}
									onChange={(newVal) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["eventTarget"] = newVal;
										setrules(rulesX);
									}}
								/>
							</PanelRow>


							<PanelRow>
								<label htmlFor="" >
									{__("Animation", "woocommerce-products-slider")}
								</label>
								<CBDropdown
									position="bottom right"
									variant="secondary"
									buttonTitle={
										animateListArgs[group.animationName] ==
											undefined
											? __("Choose", "woocommerce-products-slider")
											: animateListArgs[group.animationName].label
									}
									options={animateListArgs}
									onChange={(option, index) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["animationName"] = option.value;
										setrules(rulesX);
									}}
									values=""></CBDropdown>
							</PanelRow>
							{/* <PanelRow>
								<label htmlFor="" >
									{__("Duration", "woocommerce-products-slider")}
								</label>
								<InputControl
									className=""
									value={group.duration}
									onChange={(newVal) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["duration"] = newVal;
										setrules(rulesX);
									}}
								/>
							</PanelRow>
							<PanelRow>
								<label htmlFor="" >
									{__("Delay", "woocommerce-products-slider")}
								</label>
								<InputControl
									className=""
									value={group.delay}
									onChange={(newVal) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["delay"] = newVal;
										setrules(rulesX);
									}}
								/>
							</PanelRow> */}
						</PGtoggle>
					);
				})}
			</div>
		</div>
	);
}
class CBAnimateOn extends Component {
	constructor(props) {
		super(props);
		this.state = { showWarning: true };
		this.handleToggleClick = this.handleToggleClick.bind(this);
	}
	handleToggleClick() {
		this.setState((state) => ({
			showWarning: !state.showWarning,
		}));
	}
	render() {
		const {
			position,
			variant,
			btnClass,
			searchPlaceholder,
			options, //[{"label":"Select..","icon":"","value":""}]
			buttonTitle,
			onChange,
			animateOn,
			values,
			value,
		} = this.props;
		return (
			<div>
				<Html
					value={value}
					position={position}
					searchPlaceholder={searchPlaceholder}
					btnClass={btnClass}
					variant={variant}
					options={options}
					buttonTitle={buttonTitle}
					onChange={onChange}
					animateOn={animateOn}
					warn={this.state.showWarning}
				/>
			</div>
		);
	}
}
export default CBAnimateOn;
